import { useLocation } from 'react-router-dom';
import { FaCar, FaSearch } from 'react-icons/fa';

const EmployeeTabs = () => {
  const location = useLocation();
  const isServiceActive = location.pathname === '/empleado';
  const isSearchActive = location.pathname === '/empleado/busquedas';

  return (
    <>
      <button
        className={`tab ${isServiceActive ? 'active' : ''}`}
        onClick={() => window.location.href = '/empleado'}
      >
        <FaCar className="mr-2" />
        Cargar Service
      </button>
      <button
        className={`tab ${isSearchActive ? 'active' : ''}`}
        onClick={() => window.location.href = '/empleado/busquedas'}
      >
        <FaSearch className="mr-2" />
        Búsquedas
      </button>
    </>
  );
};

export default EmployeeTabs;